@if (tableItem[columnName] === 'Novi') {
<i class="pi  pi-circle-on text-green-500" pTooltip="{{  $any(tableItem)[columnName]  }}"></i> 
}
@if (tableItem[columnName] === 'U obradi') {
<i class="pi pi-spinner-dotted text-yellow-500" pTooltip="{{  $any(tableItem)[columnName]  }}"></i>
}
@if (tableItem[columnName] === 'Dovršen') {
<i class="pi pi-check-circle text-red-500" pTooltip="{{  $any(tableItem)[columnName]  }}"></i>
}
@if (tableItem[columnName] === 'Prenesen') {
<i class="pi pi-upload text-purple-500" pTooltip="{{  $any(tableItem)[columnName]  }}"></i>
}

@if (tableItem[columnName] === 'Predmet') {
<i class="pi pi-credit-card text-orange-500" pTooltip="{{  $any(tableItem)[columnName]  }}"></i>
}
@if (tableItem[columnName] === 'Dokument') {
<i class="pi pi-file-o text-blue-500" pTooltip="{{  $any(tableItem)[columnName]  }}"></i>
}